import { render, staticRenderFns } from "./CouponEntity.vue?vue&type=template&id=046b2f3a&scoped=true"
import script from "./CouponEntity.vue?vue&type=script&lang=js"
export * from "./CouponEntity.vue?vue&type=script&lang=js"
import style0 from "./CouponEntity.vue?vue&type=style&index=0&id=046b2f3a&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "046b2f3a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Mobaxe\\Nevo.SimAdmin.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('046b2f3a')) {
      api.createRecord('046b2f3a', component.options)
    } else {
      api.reload('046b2f3a', component.options)
    }
    module.hot.accept("./CouponEntity.vue?vue&type=template&id=046b2f3a&scoped=true", function () {
      api.rerender('046b2f3a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/CouponEntity.vue"
export default component.exports